import { render } from "./Bangsal.vue?vue&type=template&id=db11372c"
import script from "./Bangsal.vue?vue&type=script&lang=js"
export * from "./Bangsal.vue?vue&type=script&lang=js"
script.render = render

export default script